import { render, staticRenderFns } from "./BreadcrumbPage.vue?vue&type=template&id=962740e2&"
import script from "./BreadcrumbPage.vue?vue&type=script&lang=ts&"
export * from "./BreadcrumbPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports